import Icon from '@amzn/awsui-components-core/icon';
import React from 'react';
import { FxCardConfig } from 'src/services/FxRateService';
import { getFxUrl } from '../utils/welcome-banner-utils';

interface FxRateCardProps {
  fxConfig: FxCardConfig;
  fxIndex: number;
  onFxIndexChange: (index: number) => void;
  ariaLabel: string;
  label: string;
}

/**
 * @feature landing-page
 * @description FX Rate glanceable card — shows selected USD pair rate with currency selector buttons.
 * User selection is persisted in localStorage.
 */
const FxRateCard: React.FC<FxRateCardProps> = ({ fxConfig, fxIndex, onFxIndexChange, ariaLabel, label }) => {
  const handleCurrencySelect = (index: number) => {
    onFxIndexChange(index);
    localStorage.setItem('finsuite-fx-currency', fxConfig.pairs[index].target);
  };

  return (
    <div className="landing-welcome-banner__card" data-testid="fx-card">
      <a
        className="landing-welcome-banner__card-link"
        href={getFxUrl(fxConfig.pairs[fxIndex].target)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={ariaLabel}
      >
        <Icon name="external" size="small" />
      </a>
      <span className="landing-welcome-banner__card-icon">💱</span>
      <div className="landing-welcome-banner__card-content">
        <span className="landing-welcome-banner__card-label">{label}</span>
        <span className="landing-welcome-banner__card-value">{fxConfig.pairs[fxIndex].formatted}</span>
        <span className="landing-welcome-banner__card-sub landing-welcome-banner__fx-selectors">
          {fxConfig.pairs.map((pair, i) => (
            <button
              key={pair.target}
              className={`landing-welcome-banner__fx-btn ${i === fxIndex ? 'landing-welcome-banner__fx-btn--active' : ''}`}
              onClick={() => handleCurrencySelect(i)}
            >
              {pair.target}
            </button>
          ))}
        </span>
      </div>
    </div>
  );
};

export default FxRateCard;
